function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { i18n } from 'invision-core';
import LocaleKeys from '../../../locales/keys';
var GiftCardActivationListController = /*#__PURE__*/function () {
  function GiftCardActivationListController() {
    _classCallCheck(this, GiftCardActivationListController);
    this.CustomerCareLocaleKeys = LocaleKeys;
    this.viewModel = {
      shouldShowActivationList: false
    };
  }
  return _createClass(GiftCardActivationListController, [{
    key: "$onInit",
    value: function $onInit() {
      var columnDefs = [{
        field: 'Notified',
        displayName: i18n.translate(LocaleKeys.GIFT_CARD_DETAILS.SEND_DATE),
        width: 150,
        cellFilter: 'date:"short"'
      }, {
        field: 'SenderEmail',
        displayName: i18n.translate(LocaleKeys.GIFT_CARD_DETAILS.SENDER_EMAIL),
        minWidth: 150
      }, {
        field: 'RecipientName',
        displayName: i18n.translate(LocaleKeys.GIFT_CARD_DETAILS.RECIPIENT_NAME),
        minWidth: 150
      }, {
        field: 'RecipientEmail',
        displayName: i18n.translate(LocaleKeys.GIFT_CARD_DETAILS.RECIPIENT_EMAIL),
        minWidth: 150
      }];
      this.tableData = {
        columnDefs: columnDefs,
        data: this.activationList
      };
    }
  }, {
    key: "$onChanges",
    value: function $onChanges(changes) {
      if (changes.activationList) {
        this.viewModel.shouldShowActivationList = this.activationList && this.activationList.length > 0;
      }
    }
  }]);
}();
export default {
  bindings: {
    activationList: '<'
  },
  template: require('./gift.card.activation.list.html'),
  controller: GiftCardActivationListController
};